import { render, staticRenderFns } from "./c_checkout_hot.vue?vue&type=template&id=579fd06c&scoped=true"
import script from "./c_checkout_hot.vue?vue&type=script&lang=js"
export * from "./c_checkout_hot.vue?vue&type=script&lang=js"
import style0 from "./c_checkout_hot.vue?vue&type=style&index=0&id=579fd06c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579fd06c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('579fd06c')) {
      api.createRecord('579fd06c', component.options)
    } else {
      api.reload('579fd06c', component.options)
    }
    module.hot.accept("./c_checkout_hot.vue?vue&type=template&id=579fd06c&scoped=true", function () {
      api.rerender('579fd06c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_checkout_hot.vue"
export default component.exports